export default {
  tenant: "eperformax-arria.callcenterstudio.com",
  scripterLayoutKey: "ahRzfm11c3RlcmktaGl6bWV0bGVyaXIbCxIOU2NyaXB0ZXJMYXlvdXQYgIDc5NDl5wsMogElZXBlcmZvcm1heC1hcnJpYS5jYWxsY2VudGVyc3R1ZGlvLmNvbQ",
  sKey: "ahRzfm11c3RlcmktaGl6bWV0bGVyaXIVCxIIU2NyaXB0ZXIYgIDc7bnWtAoMogElZXBlcmZvcm1heC1hcnJpYS5jYWxsY2VudGVyc3R1ZGlvLmNvbQ",
  scripterName: "Store Pop Up"
};
